export default __webpack_public_path__ + "static/media/Girdle of the Ravenflight.99249155.jpg";